<template>
  <div>
    <carousel v-if="module === 'carousel'"></carousel>
    <events-map v-if="module === 'map'"></events-map>
    <internal-nav
      v-if="module === 'nav'"
      :title="title"
      :link-url="linkUrl"
      :link-label="linkLabel"
    ></internal-nav>
    <global-search v-if="module === 'search'"></global-search>
    <newsletter v-if="module === 'newsletter'"></newsletter>
  </div>
</template>

<script>
import Carousel from '@/components/carousel/Carousel'
import EventsMap from '@/components/map/EventsMap'
import InternalNav from '@/components/nav/InternalNav'
import GlobalSearch from '@/components/search/GlobalSearch'
import Newsletter from '@/components/newsletter/Newsletter'

export default {
  name: 'App',
  components: {
    Carousel,
    EventsMap,
    InternalNav,
    GlobalSearch,
    Newsletter
  },
  props: {
    module: String,
    title: String,
    linkUrl: String,
    linkLabel: String
  }
}
</script>
